<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">账套参数中心</span>
		</div>
		<div class="settings-body">
			<div class="setting-group">
				<div class="group-title">凭证处理</div>
				<div class="setting-row">
					<div class="label">凭证日期校验</div>
					<div class="control">
						<label v-for="o in checkOptions" :key="o.key">
							<input type="radio" v-model="form.voucherDateCheck" :value="o.key">{{o.title}}
						</label>
						<span class="tip">选择「限制」时，凭证日期不能晚于当前会计期间月末</span>
					</div>
				</div>
				<div class="setting-row">
					<div class="label">余额赤字检查</div>
					<div class="control">
						<label v-for="o in checkOptions" :key="o.key">
							<input type="radio" v-model="form.deficitCheck" :value="o.key">{{o.title}}
						</label>
						<span class="tip">选择「限制」时，科目余额将出现赤字则不允许保存</span>
					</div>
				</div>
				<div class="setting-row">
					<div class="label">允许跨月制单</div>
					<div class="control">
						<label><input type="radio" v-model="form.crossMonth" :value="1">是</label>
						<label><input type="radio" v-model="form.crossMonth" :value="0">否</label>
						<span class="tip">选择「否」时，凭证日期必须在当前会计月份</span>
					</div>
				</div>
			</div>

			<div class="setting-group">
				<div class="group-title">凭证编号</div>
				<div class="setting-row">
					<div class="label">编号重置方式</div>
					<div class="control">
						<label v-for="o in resetOptions" :key="o.key">
							<input type="radio" v-model="form.codeResetType" :value="o.key">{{o.title}}
						</label>
						<span class="tip">默认按月重置；改为「连续编号」后凭证号全年/跨年连续</span>
					</div>
				</div>
			</div>

			<div class="setting-group">
				<div class="group-title">账簿金额</div>
				<div class="setting-row">
					<div class="label">金额小数位数</div>
					<div class="control">
						<input type="number" min="0" max="6" v-model.number="form.amountDecimal" class="num-input"> 位
						<span class="tip">保存凭证时金额自动按此精度处理（0~6）</span>
					</div>
				</div>
				<div class="setting-row">
					<div class="label">数量小数位数</div>
					<div class="control">
						<input type="number" min="0" max="6" v-model.number="form.quantityDecimal" class="num-input"> 位（0~6）
					</div>
				</div>
			</div>

			<div class="text-center margin-top">
				<Button color="green" :loading="loading" @click="save">保存参数</Button>
				<Button color="primary" @click="openHistory">变更历史</Button>
			</div>
		</div>

		<Modal v-model="historyModal" :width="800">
			<div slot="header">账套参数变更历史</div>
			<table class="h-table" style="width:100%;">
				<tr>
					<th style="width:90px;">分组</th>
					<th style="width:130px;">参数</th>
					<th>原值</th>
					<th>新值</th>
					<th style="width:110px;">操作人</th>
					<th style="width:150px;">时间</th>
					<th style="width:70px;">操作</th>
				</tr>
				<tr v-for="h in historyDatas" :key="h.id">
					<td>{{h.module}}</td>
					<td>{{h.itemName}}</td>
					<td>{{h.oldValue}}</td>
					<td>{{h.newValue}}</td>
					<td>{{h.operatorName}}</td>
					<td>{{formatTime(h.createDate)}}</td>
					<td><span class="text-hover" @click="rollback(h)">回滚</span></td>
				</tr>
				<tr v-if="!historyDatas.length">
					<td colspan="7" class="text-center padding dark4-color">暂无变更记录</td>
				</tr>
			</table>
			<div slot="footer">
				<Button color="primary" @click="historyModal=false">关闭</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: 'SetsSettings',
		data() {
			return {
				loading: false,
				form: {},
				checkOptions: [
					{key: 0, title: '不检查'},
					{key: 1, title: '提醒'},
					{key: 2, title: '限制'}
				],
				resetOptions: [
					{key: 0, title: '连续编号'},
					{key: 1, title: '按月重置'},
					{key: 2, title: '按年重置'}
				],
				historyModal: false,
				historyDatas: []
			};
		},
		methods: {
			formatTime(t) {
				return t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '';
			},
			load() {
				this.$api.setting.setsSettings.get().then(({data}) => {
					this.form = data || {};
				});
			},
			save() {
				if (typeof this.form.amountDecimal !== 'number' || isNaN(this.form.amountDecimal)
					|| this.form.amountDecimal < 0 || this.form.amountDecimal > 6) {
					this.$Message('金额小数位数应在 0~6 之间');
					return;
				}
				if (typeof this.form.quantityDecimal !== 'number' || isNaN(this.form.quantityDecimal)
					|| this.form.quantityDecimal < 0 || this.form.quantityDecimal > 6) {
					this.$Message('数量小数位数应在 0~6 之间');
					return;
				}
				this.loading = true;
				this.$api.setting.setsSettings.save(this.form).then(() => {
					this.$Message('参数保存成功');
					this.load();
				}).finally(() => {
					this.loading = false;
				});
			},
			openHistory() {
				this.historyModal = true;
				this.$api.setting.setsSettings.history().then(({data}) => {
					this.historyDatas = data || [];
				});
			},
			rollback(h) {
				this.$Confirm(`确认将参数「${h.itemName}」回滚为「${h.oldValue}」?`).then(() => {
					this.$api.setting.setsSettings.rollback(h.id).then(() => {
						this.$Message('已回滚');
						this.openHistory();
						this.load();
					});
				});
			}
		},
		mounted() {
			this.load();
		}
	};
</script>

<style lang='less' scoped>
	.settings-body {
		padding: 20px 30px;

		.setting-group {
			border: 1px solid @border-color;
			border-radius: 4px;
			margin-bottom: 18px;

			.group-title {
					background: @tag-background-color;
				padding: 8px 15px;
				font-weight: bold;
				border-bottom: 1px solid @border-color;
			}

			.setting-row {
				display: flex;
				padding: 12px 15px;
				border-bottom: 1px solid @border-color;

				&:last-child {
					border-bottom: none;
				}

				.label {
					width: 120px;
					flex-shrink: 0;
				}

				.control {
					flex: 1;

					label {
						margin-right: 18px;
					}

					.tip {
						color: @dark4-color;
						font-size: 12px;
						margin-left: 10px;
					}

					.num-input {
						width: 70px;
					}
				}
			}
		}
	}
</style>
